import script from "./SuggestionTool.vue?vue&type=script&setup=true&lang=ts"
export * from "./SuggestionTool.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__